import {
  DomainInfo200,
  HostingDomainsV2200DomainsItem,
} from '@newfold/huapi-js/src/index.schemas';

export const addonDomainV2: HostingDomainsV2200DomainsItem = {
  // aligns with mocks.data.sites.siteActive
  id: 1,
  account_back_ref: 'WN.HP.123456',
  autogen_id: null,
  authoritative: true,
  back_reference: null,
  base_domain: 'dougclarkfinewoodworking.com',
  date_added: '2020-01-01 00:00:00',
  date_modified: '2020-01-01 01:00:00',
  date_ssl_exp: '2125-01-01 00:00:00',
  dns_status: 'host',
  docroot: 'public_html',
  domain: 'dougclarkfinewoodworking.com',
  homedir: '/home/user',
  hosting_id: 123,
  ssl_issuer: "Let's Encrypt",
  ssl_status: 'secure',
  ssl_type: 'dv',
  ssl_tier: 'Basic SSL',
  ssl_upgradeable: true,
  status: 'active',
  type: 'addon',
  setup_progress: {
    validate_error: null, // No error set (see stepData.tsx for error mapping)
    // validate_error: 'ssl_website_broken', // error, and job will not retry
    // validate_error: 'ssl_acme_check_fail', // error, but job is still trying
    validate_dns: 1,
    validate_ssl: 1,
    validate_cdn: 0,
    validate_dns_error: null,
    validate_ssl_error: null,
    // validate_ssl_error: 'ssl_website_broken',
    // validate_ssl_error: 'not_registered',
    validate_cdn_error: null,
  },
  billing_account_id: '1234567',
  billing_status: 'active',
  is_internal: true,
  nameservers: ['ns1.betabh.com', 'ns2.betabh.com'],
  // product_id: 'WN.D.1234567',
  // third_party_dns: false,
};
export const mainDomainAutogenV2: HostingDomainsV2200DomainsItem = {
  id: 2,
  account_back_ref: 'WN.HP.123456',
  autogen_id: 123,
  authoritative: true,
  back_reference: null,
  base_domain: 'website-abc123.abc.def.bluehost.me',
  date_added: '2020-01-01 00:00:00',
  date_modified: '2020-01-01 01:00:00',
  date_ssl_exp: null,
  dns_status: 'unknown',
  docroot: 'public_html/site-uuid-or-something-1',
  domain: 'website-abc123.abc.def.bluehost.me',
  homedir: '/home/user',
  hosting_id: 123,
  ssl_issuer: null,
  ssl_status: null,
  ssl_type: null,
  ssl_tier: 'Premium SSL',
  ssl_upgradeable: false,
  status: 'active',
  type: 'main',
  setup_progress: {
    validate_error: null,
    validate_dns: 2,
    validate_ssl: 2,
    validate_cdn: 2,
    validate_dns_error: null,
    validate_ssl_error: null,
    validate_cdn_error: null,
  },
  billing_account_id: null,
  billing_status: null,
  is_internal: null,
  nameservers: [],
  // product_id: null,
  // third_party_dns: null,
};
export const parkedDomainV2: HostingDomainsV2200DomainsItem = {
  // aligns with mocks.data.sites.siteActivePendingUrl
  id: 3,
  account_back_ref: 'WN.HP.123456',
  autogen_id: null,
  authoritative: true,
  back_reference: null,
  base_domain: 'url.com',
  date_added: '2020-01-01 00:00:00',
  date_modified: '2020-01-01 01:00:00',
  date_ssl_exp: null,
  dns_status: 'unknown',
  docroot: 'public_html/site-uuid-or-something-1',
  domain: 'pending.url.com',
  homedir: '/home/user',
  hosting_id: 123,
  ssl_issuer: null,
  ssl_status: null,
  ssl_type: null,
  ssl_tier: 'Premium SSL',
  ssl_upgradeable: false,
  status: 'active',
  type: 'parked',
  setup_progress: {
    validate_error: null,
    validate_dns: 2,
    validate_ssl: 0,
    validate_cdn: null,
    validate_dns_error: null,
    validate_ssl_error: null,
    validate_cdn_error: null,
  },
  billing_account_id: '1234567',
  billing_status: null,
  is_internal: false,
  nameservers: ['ns1.example.com', 'ns2.example.com'],
  // product_id: 'WN.H.1234567',
  // third_party_dns: true,
};

export const unassignedDomainV2: HostingDomainsV2200DomainsItem = {
  id: 4,
  account_back_ref: 'WN.HP.123456',
  autogen_id: null,
  authoritative: true,
  back_reference: null,
  base_domain: 'example4.com',
  date_added: '2020-01-01 00:00:00',
  date_modified: '2020-01-01 01:00:00',
  date_ssl_exp: null,
  dns_status: 'unknown',
  docroot: null,
  domain: 'sub2.example4.com',
  homedir: '/home/user',
  hosting_id: 123,
  ssl_issuer: null,
  ssl_status: null,
  ssl_type: null,
  ssl_tier: null,
  ssl_upgradeable: false,
  status: 'unassigned',
  type: 'unassigned',
  setup_progress: null,
  billing_account_id: null,
  billing_status: null,
  is_internal: null,
  nameservers: [],
  // product_id: null,
  // third_party_dns: null,
};
export const mainDomainActualV2: HostingDomainsV2200DomainsItem = {
  id: 5,
  account_back_ref: 'WN.HP.123456',
  autogen_id: null,
  authoritative: null,
  back_reference: null,
  base_domain: 'examplemain.com',
  date_added: '2020-01-01 00:00:00',
  date_modified: '2020-01-01 01:00:00',
  date_ssl_exp: '1920-01-01 00:00:00',
  dns_status: 'host',
  docroot: 'public_html',
  domain: 'examplemain.com',
  homedir: '/home/user',
  hosting_id: 123,
  ssl_issuer: 'Sectigo Limited',
  ssl_status: 'insecure',
  ssl_type: 'dv',
  ssl_tier: 'Basic SSL',
  ssl_upgradeable: true,
  status: 'active',
  type: 'main',
  setup_progress: {
    validate_error: null,
    validate_dns: 1,
    validate_ssl: 1,
    validate_cdn: 1,
    validate_dns_error: null,
    validate_ssl_error: null,
    validate_cdn_error: null,
  },
  billing_account_id: '1234567',
  billing_status: 'active',
  is_internal: true,
  nameservers: ['ns1.betabh.com', 'ns2.betabh.com'],
  // product_id: 'WN.D.1234567',
  // third_party_dns: false,
};

// waiting for Jarvis domain to be confirmed in HAL
export const preassignDomainV2: HostingDomainsV2200DomainsItem = {
  id: 6,
  account_back_ref: 'WN.HP.7891234',
  autogen_id: null,
  authoritative: true,
  back_reference: null,
  base_domain: 'preassign-domain.com',
  date_added: '2020-01-01 00:00:00',
  date_modified: '2020-01-01 01:00:00',
  date_ssl_exp: '1920-01-01 00:00:00',
  dns_status: 'unknown',
  docroot: 'public_html',
  domain: 'preassign-domain.com',
  homedir: '/home/user',
  hosting_id: 123,
  ssl_issuer: null,
  ssl_status: null,
  ssl_type: null,
  ssl_tier: null,
  ssl_upgradeable: false,
  status: 'preassign',
  type: 'addon',
  setup_progress: {
    validate_error: null, // No error set (see stepData.tsx for error mapping)
    validate_dns: 1,
    validate_ssl: 0,
    validate_cdn: 0,
    validate_dns_error: null,
    validate_ssl_error: null,
    validate_cdn_error: null,
  },
  billing_account_id: '1234567',
  billing_status: 'active',
  is_internal: false,
  nameservers: ['ns1.betabh.com', 'ns2.betabh.com'],
  // product_id: 'WN.D.1234567',
  // third_party_dns: false,
};

// waiting for Jarvis domain to be confirmed in HAL
export const preunassignDomainV2: HostingDomainsV2200DomainsItem = {
  id: 7,
  account_back_ref: 'WN.HP.7777777',
  autogen_id: null,
  authoritative: true,
  back_reference: null,
  base_domain: 'preunassign-domain.com',
  date_added: '2020-01-01 00:00:00',
  date_modified: '2020-01-01 01:00:00',
  date_ssl_exp: '1920-01-01 00:00:00',
  dns_status: 'unknown',
  docroot: 'public_html',
  domain: 'preunassign-domain.com',
  homedir: '/home/user',
  hosting_id: 123,
  ssl_issuer: null,
  ssl_status: null,
  ssl_type: null,
  ssl_tier: null,
  ssl_upgradeable: false,
  status: 'preunassign',
  type: 'addon',
  setup_progress: {
    validate_error: null, // No error set (see stepData.tsx for error mapping)
    validate_dns: 1,
    validate_ssl: 0,
    validate_cdn: 0,
    validate_dns_error: null,
    validate_ssl_error: null,
    validate_cdn_error: null,
  },
  billing_account_id: '1234567',
  billing_status: 'active',
  is_internal: false,
  nameservers: ['ns1.betabh.com', 'ns2.betabh.com'],
  // product_id: 'WN.D.1234567',
  // third_party_dns: false,
};

export const domainsListV2: DomainInfo200[] = [
  addonDomainV2,
  mainDomainAutogenV2,
  parkedDomainV2,
  unassignedDomainV2,
  mainDomainActualV2,
  preassignDomainV2,
  preunassignDomainV2,
];
